import { useMemo, useCallback } from "react";
import { useCurrentUser } from "services/currentUserService";

export const useReportPermissions = () => {
  const { data: userData, loading } = useCurrentUser();

  const reportPermissions = useMemo(() => {
    return userData?.profile?.reports || {};
  }, [userData]);

  const hasReportAccess = useCallback((reportKey) => {
    if (!reportKey) return false;
    return reportPermissions[reportKey] === true;
  }, [reportPermissions]);

  const hasAnyReportAccess = useCallback(() => {
    return Object.values(reportPermissions).some(permission => permission === true);
  }, [reportPermissions]);

  const getAccessibleReports = useCallback(() => {
    return Object.keys(reportPermissions).filter(key => reportPermissions[key] === true);
  }, [reportPermissions]);

  return {
    reportPermissions,
    hasReportAccess,
    hasAnyReportAccess,
    getAccessibleReports,
    loading,
  };
};
